<template>
  <div class="subscribe-dialog" :class="{ opened: !!value }">
    <div class="subscribe-modal">
      <div class="subscribe-modal__title">Get Terminus <br />Updates</div>
      <v-form @submit.prevent="submit">
        <v-text-field
          placeholder="Email Address"
          dark
          v-model="form.email"
          hide-details
        >
        </v-text-field>
        <v-btn type="submit" color="white" elevation="0" x-small>Sign Up</v-btn>
      </v-form>
      <v-btn
        class="close"
        icon
        @click="$emit('input', false)"
        elevation="0"
        size="12"
      >
        <v-icon color="white">$close</v-icon>
      </v-btn>
    </div>
  </div>
</template>

<script>
export default {
  name: "SubscribeModal",
  props: {
    value: Boolean
  },
  data() {
    return {
      form: { email: "" }
    };
  },
  methods: {
    async submit() {
      await this.$recaptchaLoaded();
      this.form.recaptcha = await this.$recaptcha("login");
      await this.$api.EmailSubscription.create(this.form);
      this.$emit("input", false);
      this.form = { email: "" };
    }
  }
};
</script>

<style scoped lang="scss">
.subscribe-dialog {
  position: fixed;
  right: 30px;
  bottom: 30px;
  text-align: center;
  &:not(.opened) {
    display: none;
  }
}
.subscribe-modal {
  width: 258px;
  max-width: calc(100vw - 60px);
  height: 258px;
  background-image: url("~@/assets/popup_bg.png");
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
  color: white;
  padding: 25px 50px 0;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;

  &__title {
    font-size: 20px;
    line-height: 1;
  }

  &::v-deep {
    .v-text-field {
      padding-top: 3px;
      input {
        text-align: center;
        font-size: 12px !important;
        &::placeholder {
          color: white !important;
        }
      }
    }

    .v-btn.v-size--x-small {
      width: 100%;
      height: 24px !important;
      font-size: 12px !important;
      border-radius: 5px;
      margin-top: 15px;
    }

    .v-btn.close {
      position: relative;
      margin: 15px auto 0;

      height: 30px;
      width: 30px;
      &::before,
      &::after {
        height: 30px;
        width: 30px;
      }
      .v-btn__content .v-icon {
        &::before,
        &::after {
          height: 24px;
          width: 24px;
          font-size: 24px;
        }
      }
    }

    .v-input__append-inner {
      margin-top: 10px !important;
    }

    .theme--dark.v-text-field--outlined:not(.v-input--is-focused):not(.v-input--has-state)
      > .v-input__control
      > .v-input__slot
      fieldset {
      color: rgba(255, 255, 255, 0.66);
    }

    .close {
      right: 0px;
      top: 0px;
    }

    .v-btn__content {
      color: $cmf-darkgrey !important;
      letter-spacing: 0;
      text-transform: none;
      font-weight: normal;
    }
  }
}
</style>
